// Copyright © Perilous Games, Ltd., 2025. All Rights Reserved. Coded by Alexander Fields https://www.alexanderfields.me on 2025-07-02 17:26:25

/**
 * @fileoverview Full-screen loading spinner component
 * @module components/shared/Loader
 * @description
 *   Simple full-screen loading indicator displayed during Suspense fallback
 *   while lazy-loaded components are being fetched. Renders a centered
 *   spinning circular animation on the primary background.
 */

import React from 'react'

/**
 * @component Loader
 * @description Full-screen loading spinner with rotating animation.
 * @returns {JSX.Element} Loading spinner component
 */
const Loader = () => {
  return (
    <div className='flex w-full h-screen items-center justify-center bg-primary'>
      <div className='animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-500'></div>
    </div>
  )
}

export default Loader
